import './select-buffer.scss';

import { startOfDay } from 'date-fns';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { HandleData } from '@core/app/scripts/services/handle-data';
import { LocationManager } from '@shared/app/scripts/services/location-manager';
import { TimeKeeper } from '@core/app/scripts/services/time-keeper';

/*
 * Component responsible for /select-buffer route.
 */
angular
  .module('posApp')
  .directive(
    'selectBuffer',
    (
      $log: ng.ILogService,
      displayMessage: DisplayMessage,
      handleData: HandleData,
      locationManager: LocationManager,
      navigateTo: NavigateTo,
      timeKeeper: TimeKeeper,
      translate: ng.translate.ITranslateService,
      pos,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./select-buffer.html').default,

      link: function ($scope: any, element, attrs) {
        const $translate = translate;

        // Type of transactions
        const cSales = $translate.instant('Sales');
        const cTransits = $translate.instant('Transit');
        const cAllText = $translate.instant('All');

        const year = '';
        $scope.smartBufferList = [];
        $scope.bufferItems = [];

        $scope.types = [
          {
            type: undefined,
            typestr: cAllText,
          },
          {
            type: 2,
            typestr: cSales,
          },
          {
            type: 3,
            typestr: cTransits,
          },
        ];
        $scope.shopnames = [
          {
            shopId: null,
            shopnametxt: cAllText,
          },
        ];
        $scope.months = [
          {
            month: cAllText,
          },
        ];
        $scope.years = [
          {
            year: cAllText,
          },
        ];
        $scope.datebuff = null;
        $scope.shopId = null;

        $scope.selectedLine = -1;

        $scope.loadBufferTransactions = () => {
          //Get all this todays transactions
          //Parameter transaction is added for buffering, if so transaction='buffer'
          //Get all this month's transactions
          //Parameter transaction is added for buffering, if so transaction='buffer'
          const oFilter = {};
          //Reset List
          $scope.bufferItems = [];

          oFilter['created.date'] = {
            $gte: $scope.datebuff,
          };
          if ($scope.shopId && $scope.shopId !== null) {
            oFilter['shop.id'] = $scope.shopId;
          }

          oFilter.active = true;

          //if (pos.transaction.buffer_id) oFilter["_id"] = {$ne: pos.transaction.buffer_id}

          handleData.getData(
            {
              resource: 'buffer',
            },
            oFilter,
            (res) => {
              let i;

              if (!res.data || res.data.length === 0) {
                $log.log('[Buffer] No items to load');
                return;
              }

              $log.log('[Buffer] Buffered transactions loading');

              $scope.bufferItems = res.data;

              //Remove the current transaction
              if (pos.transaction && pos.transaction.buffer_id) {
                $scope.bufferItems = _.reject($scope.bufferItems, (obj) => {
                  if (
                    obj._id === undefined ||
                    obj._id == pos.transaction.buffer_id
                  ) {
                    return true;
                  }
                  return false;
                });
              }

              $scope.bufferItems.sort((a, b) => {
                if (a.created && b.created) {
                  a = a.created.date;
                  b = b.created.date;
                  return a > b ? -1 : a < b ? 1 : 0;
                }
              });

              for (i in $scope.bufferItems) {
                //Change type in string to show
                if ($scope.bufferItems[i].type == 2) {
                  $scope.bufferItems[i].type = ' ';
                } else {
                  $scope.bufferItems[i].type = 'T';
                }
              }
            },
            null,
            {
              fields: [
                'cashier',
                'shop',
                'created',
                'totalAmount',
                'totalDiscount',
                'totalNumber',
                'customer',
              ],
            },
          );
        };

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.selectBuffer = (buffer) => {
          displayMessage.showLoading();
          $log.log(buffer);

          handleData.getData(
            {
              resource: 'buffer',
            },
            {
              _id: buffer._id,
            },
            (r) => {
              if (!r.data || r.data.length === 0) {
                $log.error('[Buffer] Could not reload buffered transaction!');
                return;
              }

              const buffer = r.data[0];
              //Set the new transactions buffer_id to the buffer's _id
              buffer.buffer_id = buffer._id;
              //Remove the _id
              delete buffer._id;
              delete buffer.created;
              delete buffer.modified;

              // Now store the data in the POS
              pos.reloadTransaction(buffer);

              $scope.navigateToView('pos.route#pos');
            },
          );
        };

        $scope.getClass = (ind) => {
          if (ind === $scope.selectedLine) {
            return 'ui-btn-active';
          } else {
            return '';
          }
        };

        // ngOnInit
        //Clear previous buffer items
        $scope.bufferItems = [];

        for (const wareHouse in locationManager.all) {
          $scope.shopnames.push({
            shopId: locationManager.all[wareHouse].wh,
            shopnametxt: locationManager.all[wareHouse].name,
          });
        }

        //Load with defaults
        $scope.datebuff = startOfDay(timeKeeper.getLocalDate());
        $scope.shopId = locationManager.current.wh;

        $scope.loadBufferTransactions();

        $scope.selectCurrentLine = (currentLine) => {
          $log.log('currentLine: ' + currentLine._id);
          $scope.selectedRow = currentLine;
          $scope.toggleSelect(currentLine._id);
        };

        $scope.toggleSelect = (ind) => {
          $scope.selectedLine = ind;
        };

        //Reload transactions after change the search texts
        $scope.searchOnBlur = () => {
          $scope.loadBufferTransactions();
        };
      },
    }),
  );
